import React from 'react';
import { Progress } from 'reactstrap';
import { TopicStatus } from '../../../../services/types/Toolkit';

interface Props {
  status: TopicStatus;
}

const TopicStatusBar = (props: Props) => {
  const { status } = props;
  let value;
  if (status === TopicStatus.Progress) {
    value = 50;
  } else if (status === TopicStatus.Full) {
    value = 100;
  } else {
    value = 0;
  }

  return (
    <div className="progress-wrap progress-wrap--small">
      <Progress value={value} />
    </div>
  );
};

export default TopicStatusBar;
